import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@7f-ui/components/skeleton/skeleton';
import { SkeletonCards } from '@shared/composites/skeleton-cards';
import type { CSSProperties } from 'react';
const MOBILE_SHEET_HEADER_HEIGHT = '8.5rem';
// oxlint-disable-next-line typescript/no-unsafe-type-assertion -- CSS custom property is not in CSSProperties
const mobileSheetStyle = {
  '--map-loading-sheet-header-height': MOBILE_SHEET_HEADER_HEIGHT
} as CSSProperties;
export function MapPageLoadingShell() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="scrollbar-none relative h-content overflow-y-auto md:grid md:grid-cols-[1fr_375px] md:*:min-h-0 xlg:grid-cols-[1064px_1fr]"><DesktopSidebarSkeleton /><MapCanvasPlaceholder /><MobileBottomSheetSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function DesktopSidebarSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-6"><Skeleton className="h-10 md:w-4/6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="sticky -top-6 z-10 bg-white px-6 py-4"><FilterSkeletonRow /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative z-10 hidden shadow-elevation3 md:block"><div className="z-10 flex h-full flex-col overflow-hidden bg-white py-6">{t0}{t1}<div className="flex flex-col gap-4"><SliderSectionSkeleton /><SliderSectionSkeleton /><SliderSectionSkeleton /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function SliderSectionSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-6"><Skeleton className="h-8 w-5/6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="flex flex-col gap-4 py-2">{t0}<div className="grid grid-cols-3 gap-4 px-6 xlg:grid-cols-4"><SkeletonCards variant="square" count={3} /><SkeletonCards variant="square" count={1} className="hidden xlg:block" /></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// No skeleton for the map itself — the real map simply appears when it's
// ready. This div only reserves the grid column / mobile backdrop.
function MapCanvasPlaceholder() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="fixed inset-0 z-0 bg-primary/5 md:relative md:h-full md:min-h-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function MobileBottomSheetSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...mobileSheetStyle,
      top: "calc(100% - var(--map-loading-sheet-header-height))"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid justify-items-center gap-4 px-6 pt-2"><Skeleton className="h-1.5 w-9 rounded-full" /><Skeleton className="h-8 w-40" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="sticky top-0 min-h-[var(--map-loading-sheet-header-height)] rounded-t-3xl bg-white pb-4">{t1}<div className="pt-4"><FilterSkeletonRow className="px-6" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative z-10 pb-6 md:hidden" style={t0}><div className="overflow-hidden rounded-t-3xl bg-white shadow-elevation3">{t2}<div className="relative overflow-hidden bg-white pt-px"><div className="flex flex-col gap-6 pb-6"><MobileSliderSectionSkeleton /><MobileSliderSectionSkeleton /></div></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function MobileSliderSectionSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-6"><Skeleton className="h-7 w-5/6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="flex flex-col gap-4">{t0}<div className="flex gap-4 overflow-hidden px-6"><SkeletonCards variant="square" mobileSize="fixed" count={2} className="shrink-0" /></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function FilterSkeletonRow(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = ["flex flex-wrap gap-2", className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.join(" ");
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton className="h-10 w-28 rounded-full" />;
    t4 = <Skeleton className="h-10 w-32 rounded-full" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}